/* eslint-disable react/prop-types */
import React from "react";

import { Facebook, Instagram, LinkedIn, Twitter } from "@mui/icons-material";

import { Box, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import siteData from "../../../../_data";
const {
  siteInfo: { socialMediaLinks },
} = siteData;
function SocialLink({ href, icon: IconComponent, color, customfontsize }) {
  return (
    <Box component={Link} to={href} target="_blank" sx={{ pr: 1, m: 0 }}>
      <IconComponent style={{ fontSize: `${1.5 * customfontsize}px`, color }} />
    </Box>
  );
}

function SocialLinks({ customfontsize }) {
  const { palette } = useTheme();
  const {
    socialMediaColors: { facebook, instagram, linkedin, twitter },
  } = palette;
  const socialMedia = [
    { href: socialMediaLinks.facebook, icon: Facebook, color: facebook.main },
    {
      href: socialMediaLinks.instagram,
      icon: Instagram,
      color: instagram.main,
    },
    { href: socialMediaLinks.linkedin, icon: LinkedIn, color: linkedin.main },
    { href: socialMediaLinks.twitter, icon: Twitter, color: twitter.main },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        padding: 0,
        justifyContent: "start",
        width: "100%",
      }}
    >
      {socialMedia.map(({ href, icon, color }, index) => (
        <SocialLink
          key={index}
          href={href}
          icon={icon}
          color={color}
          customfontsize={customfontsize}
        />
      ))}
    </Box>
  );
}

export default SocialLinks;
